var divider_viewer_rtlignore_default = {
  "divider-container": "MxHee",
  "divider-container--double": "AhNwi",
  "divider": "yNrM7",
  "divider--single": "MRVy9",
  "divider--double": "_2TwbS",
  "divider--dashed": "vcnPq",
  "divider--dotted": "ovZSJ",
  "divider--small": "q-h6u",
  "divider--medium": "ZTza4",
  "divider--large": "JKWCk",
  "divider--left": "QW4wf",
  "divider--center": "B7tbr",
  "divider--right": "zWsxT",
  "svgFixerContainer": "hyyv-",
  "emptyChar": "sf9uV"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
